import { InputFormat, OutputFormat, PandocJson } from "./types"
import { isBinary } from "./utils";

  export async function pandocServer(
    input: string | File,
    from: InputFormat,
    to: OutputFormat,
    opts: {} = {}
  ): Promise<PandocJson | string | Blob | undefined> {

    let text: string;

    if (!input) return;
    if (input instanceof File) {
      if (isBinary(from)) {
        // for binary formats, read as ArrayBuffer and convert to base64
        const buffer = await input.arrayBuffer();
        text = btoa(String.fromCharCode(...new Uint8Array(buffer)));
      } else {
        // for text formats, read as text
        text = await input.text();
      }
    } else {
      text = input;
    }

    // For Vitest
    const isNodeTest = typeof window === "undefined";
    const url = isNodeTest
      ? `${process.env.PANDOC_SERVER}:${process.env.PANDOC_TEST_SERVER_PORT}/`
      // For production
      : (import.meta.env.MODE === "development")
        ? "/api/pandoc"
        : import.meta.env.VITE_PANDOC_PROD_SERVER

    try {
      const response = await fetch(url as string, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          text,
          from,
          to,
          ...opts
        })
      });

      if (!response.ok) {
        const errText = await response.text();
        console.error("Server returned:", errText);
        throw new Error(`Server error: ${response.status}`);
      }

      if (to === "json") {
        return await response.json();
      }

      if (to === "docx") {
        return await response.blob(); // binary
      }

      return await response.text(); // html, markdown, etc.

    } catch (error) {
      console.error("Pandoc conversion failed:", "Sent request to:", url, "\n", error);
      throw error;
    }
  }